import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FichaMedicaService } from '../../services/ficha-medica.service';
import { URL_DOCS } from 'src/app/config/config';
import { FunctionsService } from 'src/app/services/functions.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-consultas-previas2',
  templateUrl: './consultas-previas2.component.html',
  styleUrls: ['./consultas-previas2.component.css']
})
export class ConsultasPrevias2Component implements OnInit, OnChanges {
  @Input() consulta: any = {};
  @Input() selectedView: string = '';

  isLoading: boolean = true;

  // ✅ Full + UI
  consultas_pasadas_full: any[] = [];
  consultas_pasadas_ui: any[] = [];

  documentos_paciente: any[] = [];

  expandedIndex: number | null = null;

  URL_DOCUMENTS = URL_DOCS;

  tiposDocumentosTabs = [
    { id: 'anamnesis', label: 'Anamnesis', icon: 'fi fi-rr-stethoscope' },
    { id: 'diagnosticos', label: 'Diagnósticos e indicaciones', icon: 'fi fi-rr-doctor' },
    { id: 'recetas', label: 'Recetas', icon: 'fi fi-rr-document-signed' },
    { id: 'certificados', label: 'Certificados', icon: 'fi fi-rr-document' },
    { id: 'examenes', label: 'Órdenes de exámenes', icon: 'fi fi-rr-document' },
    { id: 'licencias', label: 'Licencias', icon: 'fi fi-rr-document' },
    { id: 'otros', label: 'Otros documentos', icon: 'fi fi-rr-document' },
  ];

  selectedTab: string = 'anamnesis';

  constructor(
    private fichaMedicaService: FichaMedicaService,
    private _functions: FunctionsService,
    public _generalServices: GeneralService
  ) {}

  ngOnInit(): void {
    this.getFichaPaciente();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedView'] && !changes['selectedView'].firstChange) {
      this.applyViewFilter();
    }
  }

  getFichaPaciente() {
  this.isLoading = true;

  this.fichaMedicaService.getFichaPaciente({
    paciente: this.consulta?.rut_paciente,
    doc_id: null,
    date: null
  })
  .then((result: any) => {
    const consultas = (result.consultas || []);

    for (let c of consultas) {
      // ✅ Fecha base real (robusta)
      const fecha = this.parseAppointmentDate(c);

      // ✅ Hora robusta (soporta HH:mm o HH:mm:ss)
      const hora = (c.horaConsulta || c.tel_doc_app_appointment_hour || c.hora || '00:00').toString();

      // ✅ timestamp para ordenar DESC (año, mes, día, hora, min, seg)
      c._sortTs = this.buildSortTs(fecha, hora);

      // ===== Tu formateo UI (después de calcular _sortTs) =====
      c.horaConsulta = this.normalizeHora(hora);

      c.tel_doc_app_appointment_date = this._functions.formatApptDate(fecha, c.horaConsulta);
      c.dateText = c.tel_doc_app_appointment_date.text;

      c.diagnosticos = this.formatFiles(c.diagnosticos || []);
      c.prescripciones = this.formatFiles(c.prescripciones || []);
      c.documentosMedico = this.formatFiles(c.documentosMedico || []);
      c.medical_orders = this.formatFiles(c.medical_orders || []);
    }

    // ✅ Orden DESC: más reciente -> más antigua
    this.consultas_pasadas_full = [...consultas].sort(
      (a: any, b: any) => (b._sortTs ?? 0) - (a._sortTs ?? 0)
    );

    this.documentos_paciente = result.documentos || [];

    this.applyViewFilter();
    this.isLoading = false;
  })
  .catch((error: any) => {
    console.log(error);
    this.isLoading = false;
  });
}

private parseAppointmentDate(c: any): Date {
  // 1) Caso principal: viene como { date: Date, ... }
  const d1 = c?.tel_doc_app_appointment_date?.date;
  if (d1 && d1 instanceof Date && !isNaN(d1.getTime())) return d1;

  // 2) Si viene como string ISO o similar
  const raw = c?.tel_doc_app_appointment_date;
  if (typeof raw === 'string') {
    const d = new Date(raw);
    if (!isNaN(d.getTime())) return d;
  }

  // 3) Si viene como Date directo
  if (raw instanceof Date && !isNaN(raw.getTime())) return raw;

  // 4) fallback: hoy (evita NaN)
  return new Date();
}

private normalizeHora(hora: string): string {
  // Devuelve "HH:mm" para UI (si viene HH:mm:ss)
  const parts = (hora || '00:00').split(':');
  const hh = (parts[0] || '00').padStart(2, '0');
  const mm = (parts[1] || '00').padStart(2, '0');
  return `${hh}:${mm}`;
}

// ✅ Usa HH:mm:ss si existe para ordenar mejor dentro del mismo minuto
private buildSortTs(fecha: Date, hora: string): number {
  const safe = (hora || '00:00').toString().trim();
  const parts = safe.split(':');

  const hh = parseInt(parts[0], 10) || 0;
  const mm = parseInt(parts[1], 10) || 0;
  const ss = parseInt((parts[2] || '0').split('.')[0], 10) || 0;

  const d = new Date(fecha);
  d.setHours(hh, mm, ss, 0);
  return d.getTime();
}



  private applyViewFilter(): void {
    const isPaciente = (this.selectedView === 'paciente');

    // ✅ Si NO es paciente => solo la última (la primera porque ya está ordenado desc)
    this.consultas_pasadas_ui = isPaciente
      ? [...this.consultas_pasadas_full]
      : (this.consultas_pasadas_full.length ? [this.consultas_pasadas_full[0]] : []);

    // Si quieres que al mostrar lista quede colapsado siempre:
    if (isPaciente) this.expandedIndex = null;
  }

  // ✅ Crea timestamp fecha+hora para ordenar
 
  private formatFiles(lista: any[]): any[] {
    if (!Array.isArray(lista)) return [];

    let ind = 1;
    return lista.map((file: any) => {
      if (file?.file_name) {
        const ind_st = (100 + ind).toString().substring(1);
        file.file_name_desc = file.file_name.replace('XX', ind_st);
        ind++;
      }
      return file;
    });
  }

  verDetalle(idx: number): void {
    this.expandedIndex = (this.expandedIndex === idx) ? null : idx;
  }

  getCertificadosTipoCertificado(appt: any): any[] {
    return appt.medical_orders?.filter((m: any) => m.med_ord_med_ord_typ_id === 2) || [];
  }

  getCertificadosTipoExamen(appt: any): any[] {
    return appt.medical_orders?.filter((m: any) => m.med_ord_med_ord_typ_id === 3) || [];
  }

  getNombreDocumento(doc: any): string {
  // 1) Si viene att_name, suele ser el nombre real del archivo
  // Ej: "230-0H7AIe6hE65YsdH5xC6e-hola.pdf"
  const nameFromAttName = (doc?.att_name || '').toString().trim();
  if (nameFromAttName) {
    return this.prettyFileName(nameFromAttName);
  }

  // 2) Si no, lo sacamos desde att_path (última parte)
  // Ej: "/230/230/230-0H7AIe6hE65YsdH5xC6e-hola.pdf"
  const path = (doc?.att_path || '').toString().trim();
  if (path) {
    const last = path.split('/').filter(Boolean).pop() || '';
    return this.prettyFileName(last);
  }

  // 3) Fallback
  return doc?.att_typ_name || 'Documento';
}

private prettyFileName(file: string): string {
  // Quitar querystring si existiera
  let clean = file.split('?')[0];

  // Si el nombre viene con prefijo "230-xxxxx-hola.pdf"
  // nos quedamos con lo último después del último "-"
  // (si quieres conservar todo, comenta este bloque)
  const base = clean.split('/').pop() || clean;
  const parts = base.split('-');
  const lastPart = parts.length > 1 ? parts[parts.length - 1] : base;

  // Opcional: devolver sin extensión
  // return lastPart.replace(/\.[^/.]+$/, '');

  return lastPart;
}

}
